import React from 'react';

import Popover, { PopoverProps } from '@mui/material/Popover';

type ToolbarPopoverProps = {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  children: React.ReactNode;
  /** ポップアップの幅 (デフォルト: 320) */
  width?: number;
  /** 最大高さ (デフォルト: 500) */
  maxHeight?: number;
  /** anchorOrigin (デフォルト: bottom-right) */
  anchorOrigin?: PopoverProps['anchorOrigin'];
  /** transformOrigin (デフォルト: top-right) */
  transformOrigin?: PopoverProps['transformOrigin'];
};

/**
 * ツールバー用の共通ポップオーバーラッパー。
 * 統一されたスタイル（角丸、幅、マージン）を適用する。
 */
const ToolbarPopover: React.FC<ToolbarPopoverProps> = ({
  open,
  anchorEl,
  onClose,
  children,
  width = 320,
  maxHeight = 500,
  anchorOrigin = { vertical: 'bottom', horizontal: 'right' },
  transformOrigin = { vertical: 'top', horizontal: 'right' },
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      slotProps={{
        paper: {
          sx: {
            width,
            maxHeight,
            overflow: 'auto',
            borderRadius: 2,
            mt: 0.5,
          },
        },
      }}
    >
      {children}
    </Popover>
  );
};

export default ToolbarPopover;
